import { render } from "./UpdateTrainingForm.vue?vue&type=template&id=1bc3b0be&scoped=true"
import script from "./UpdateTrainingForm.vue?vue&type=script&lang=js"
export * from "./UpdateTrainingForm.vue?vue&type=script&lang=js"

import "./UpdateTrainingForm.vue?vue&type=style&index=0&id=1bc3b0be&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc3b0be"]])

export default __exports__